// CANONICAL COPY (GH #7115). src/constants/frameworks/nistCsf20.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

const FRAMEWORK_NIST_CSF20 = {
  id: 'fw-nist-csf-20',
  type: 'standard',
  name: 'NIST Cybersecurity Framework 2.0',
  shortName: 'NIST CSF 2.0',
  abbrev: 'NIST',
  description:
    'NIST CSF 2.0 — 106 subcategory outcomes across 6 functions: Govern (GV), Identify (ID), Protect (PR), Detect (DE), Respond (RS) and Recover (RC)',
  color: '#4ade80',
  version: '2.0',
  sectionKeyDepth: 1,
  // The six CSF 2.0 Functions, as named in this framework's own description.
  sections: [
    { key: 'GV', name: 'Govern' },
    { key: 'ID', name: 'Identify' },
    { key: 'PR', name: 'Protect' },
    { key: 'DE', name: 'Detect' },
    { key: 'RS', name: 'Respond' },
    { key: 'RC', name: 'Recover' },
  ],
  mappings: [
    { externalId: 'GV.OC-01', scfId: 'SCF-MSS-001', ref: 'GV.OC-01' },
    { externalId: 'GV.OC-02', scfId: 'SCF-MSS-001', ref: 'GV.OC-02' },
    { externalId: 'GV.OC-03', scfId: 'SCF-GOV-009', ref: 'GV.OC-03' },
    { externalId: 'GV.OC-04', scfId: 'SCF-GOV-004', ref: 'GV.OC-04' },
    { externalId: 'GV.OC-05', scfId: 'SCF-RSK-001', ref: 'GV.OC-05' },
    { externalId: 'GV.RM-01', scfId: 'SCF-RSK-001', ref: 'GV.RM-01' },
    { externalId: 'GV.RM-02', scfId: 'SCF-RSK-001', ref: 'GV.RM-02' },
    { externalId: 'GV.RM-03', scfId: 'SCF-RSK-001', ref: 'GV.RM-03' },
    { externalId: 'GV.RM-04', scfId: 'SCF-RSK-002', ref: 'GV.RM-04' },
    { externalId: 'GV.RM-05', scfId: 'SCF-MSS-003', ref: 'GV.RM-05' },
    { externalId: 'GV.RM-06', scfId: 'SCF-RSK-001', ref: 'GV.RM-06' },
    { externalId: 'GV.RM-07', scfId: 'SCF-RSK-001', ref: 'GV.RM-07' },
    { externalId: 'GV.RR-01', scfId: 'SCF-GOV-004', ref: 'GV.RR-01' },
    { externalId: 'GV.RR-02', scfId: 'SCF-GOV-002', ref: 'GV.RR-02' },
    { externalId: 'GV.RR-03', scfId: 'SCF-MSS-002', ref: 'GV.RR-03' },
    { externalId: 'GV.RR-04', scfId: 'SCF-PPL-002', ref: 'GV.RR-04' },
    { externalId: 'GV.PO-01', scfId: 'SCF-GOV-001', ref: 'GV.PO-01' },
    { externalId: 'GV.PO-02', scfId: 'SCF-GOV-001', ref: 'GV.PO-02' },
    { externalId: 'GV.OV-01', scfId: 'SCF-MSS-006', ref: 'GV.OV-01' },
    { externalId: 'GV.OV-02', scfId: 'SCF-AUD-001', ref: 'GV.OV-02' },
    { externalId: 'GV.OV-03', scfId: 'SCF-MSS-007', ref: 'GV.OV-03' },
    { externalId: 'GV.SC-01', scfId: 'SCF-VDR-001', ref: 'GV.SC-01' },
    { externalId: 'GV.SC-02', scfId: 'SCF-VDR-003', ref: 'GV.SC-02' },
    { externalId: 'GV.SC-03', scfId: 'SCF-VDR-001', ref: 'GV.SC-03' },
    { externalId: 'GV.SC-04', scfId: 'SCF-VDR-001', ref: 'GV.SC-04' },
    { externalId: 'GV.SC-05', scfId: 'SCF-VDR-003', ref: 'GV.SC-05' },
    { externalId: 'GV.SC-06', scfId: 'SCF-VDR-001', ref: 'GV.SC-06' },
    { externalId: 'GV.SC-07', scfId: 'SCF-VDR-004', ref: 'GV.SC-07' },
    { externalId: 'GV.SC-08', scfId: 'SCF-INC-001', ref: 'GV.SC-08' },
    { externalId: 'GV.SC-09', scfId: 'SCF-VDR-002', ref: 'GV.SC-09' },
    { externalId: 'GV.SC-10', scfId: 'SCF-VDR-003', ref: 'GV.SC-10' },
    { externalId: 'ID.AM-01', scfId: 'SCF-AST-001', ref: 'ID.AM-01' },
    { externalId: 'ID.AM-02', scfId: 'SCF-AST-001', ref: 'ID.AM-02' },
    { externalId: 'ID.AM-03', scfId: 'SCF-NET-001', ref: 'ID.AM-03' },
    { externalId: 'ID.AM-04', scfId: 'SCF-AST-001', ref: 'ID.AM-04' },
    { externalId: 'ID.AM-05', scfId: 'SCF-AST-001', ref: 'ID.AM-05' },
    { externalId: 'ID.AM-07', scfId: 'SCF-DAT-001', ref: 'ID.AM-07' },
    { externalId: 'ID.AM-08', scfId: 'SCF-OPS-005', ref: 'ID.AM-08' },
    { externalId: 'ID.RA-01', scfId: 'SCF-OPS-004', ref: 'ID.RA-01' },
    { externalId: 'ID.RA-02', scfId: 'SCF-GOV-007', ref: 'ID.RA-02' },
    { externalId: 'ID.RA-03', scfId: 'SCF-RSK-001', ref: 'ID.RA-03' },
    { externalId: 'ID.RA-04', scfId: 'SCF-RSK-001', ref: 'ID.RA-04' },
    { externalId: 'ID.RA-05', scfId: 'SCF-RSK-001', ref: 'ID.RA-05' },
    { externalId: 'ID.RA-06', scfId: 'SCF-RSK-001', ref: 'ID.RA-06' },
    { externalId: 'ID.RA-07', scfId: 'SCF-RSK-001', ref: 'ID.RA-07' },
    { externalId: 'ID.RA-08', scfId: 'SCF-OPS-004', ref: 'ID.RA-08' },
    { externalId: 'ID.RA-09', scfId: 'SCF-VDR-001', ref: 'ID.RA-09' },
    { externalId: 'ID.RA-10', scfId: 'SCF-VDR-001', ref: 'ID.RA-10' },
    { externalId: 'ID.IM-01', scfId: 'SCF-AUD-002', ref: 'ID.IM-01' },
    { externalId: 'ID.IM-02', scfId: 'SCF-MSS-007', ref: 'ID.IM-02' },
    { externalId: 'ID.IM-03', scfId: 'SCF-MSS-007', ref: 'ID.IM-03' },
    { externalId: 'ID.IM-04', scfId: 'SCF-INC-004', ref: 'ID.IM-04' },
    { externalId: 'PR.AA-01', scfId: 'SCF-IAM-002', ref: 'PR.AA-01' },
    { externalId: 'PR.AA-02', scfId: 'SCF-IAM-008', ref: 'PR.AA-02' },
    { externalId: 'PR.AA-03', scfId: 'SCF-IAM-003', ref: 'PR.AA-03' },
    { externalId: 'PR.AA-04', scfId: 'SCF-IAM-008', ref: 'PR.AA-04' },
    { externalId: 'PR.AA-05', scfId: 'SCF-IAM-005', ref: 'PR.AA-05' },
    { externalId: 'PR.AA-06', scfId: 'SCF-PHY-001', ref: 'PR.AA-06' },
    { externalId: 'PR.AT-01', scfId: 'SCF-PPL-003', ref: 'PR.AT-01' },
    { externalId: 'PR.AT-02', scfId: 'SCF-PPL-003', ref: 'PR.AT-02' },
    { externalId: 'PR.DS-01', scfId: 'SCF-NET-005', ref: 'PR.DS-01' },
    { externalId: 'PR.DS-02', scfId: 'SCF-NET-005', ref: 'PR.DS-02' },
    { externalId: 'PR.DS-10', scfId: 'SCF-DAT-004', ref: 'PR.DS-10' },
    { externalId: 'PR.DS-11', scfId: 'SCF-BCM-003', ref: 'PR.DS-11' },
    { externalId: 'PR.PS-01', scfId: 'SCF-OPS-005', ref: 'PR.PS-01' },
    { externalId: 'PR.PS-02', scfId: 'SCF-OPS-004', ref: 'PR.PS-02' },
    { externalId: 'PR.PS-03', scfId: 'SCF-PHY-013', ref: 'PR.PS-03' },
    { externalId: 'PR.PS-04', scfId: 'SCF-OPS-006', ref: 'PR.PS-04' },
    { externalId: 'PR.PS-05', scfId: 'SCF-OPS-010', ref: 'PR.PS-05' },
    { externalId: 'PR.PS-06', scfId: 'SCF-DEV-001', ref: 'PR.PS-06' },
    { externalId: 'PR.IR-01', scfId: 'SCF-NET-003', ref: 'PR.IR-01' },
    { externalId: 'PR.IR-02', scfId: 'SCF-PHY-005', ref: 'PR.IR-02' },
    { externalId: 'PR.IR-03', scfId: 'SCF-OPS-011', ref: 'PR.IR-03' },
    { externalId: 'PR.IR-04', scfId: 'SCF-OPS-002', ref: 'PR.IR-04' },
    { externalId: 'DE.CM-01', scfId: 'SCF-OPS-007', ref: 'DE.CM-01' },
    { externalId: 'DE.CM-02', scfId: 'SCF-PHY-004', ref: 'DE.CM-02' },
    { externalId: 'DE.CM-03', scfId: 'SCF-OPS-007', ref: 'DE.CM-03' },
    { externalId: 'DE.CM-06', scfId: 'SCF-OPS-007', ref: 'DE.CM-06' },
    { externalId: 'DE.CM-09', scfId: 'SCF-OPS-007', ref: 'DE.CM-09' },
    { externalId: 'DE.AE-02', scfId: 'SCF-INC-002', ref: 'DE.AE-02' },
    { externalId: 'DE.AE-03', scfId: 'SCF-OPS-006', ref: 'DE.AE-03' },
    { externalId: 'DE.AE-04', scfId: 'SCF-INC-002', ref: 'DE.AE-04' },
    { externalId: 'DE.AE-06', scfId: 'SCF-INC-002', ref: 'DE.AE-06' },
    { externalId: 'DE.AE-07', scfId: 'SCF-GOV-007', ref: 'DE.AE-07' },
    { externalId: 'DE.AE-08', scfId: 'SCF-INC-002', ref: 'DE.AE-08' },
    { externalId: 'RS.MA-01', scfId: 'SCF-INC-001', ref: 'RS.MA-01' },
    { externalId: 'RS.MA-02', scfId: 'SCF-INC-002', ref: 'RS.MA-02' },
    { externalId: 'RS.MA-03', scfId: 'SCF-INC-003', ref: 'RS.MA-03' },
    { externalId: 'RS.MA-04', scfId: 'SCF-INC-003', ref: 'RS.MA-04' },
    { externalId: 'RS.MA-05', scfId: 'SCF-INC-003', ref: 'RS.MA-05' },
    { externalId: 'RS.AN-03', scfId: 'SCF-INC-003', ref: 'RS.AN-03' },
    { externalId: 'RS.AN-06', scfId: 'SCF-INC-005', ref: 'RS.AN-06' },
    { externalId: 'RS.AN-07', scfId: 'SCF-INC-005', ref: 'RS.AN-07' },
    { externalId: 'RS.AN-08', scfId: 'SCF-INC-002', ref: 'RS.AN-08' },
    // "Internal and external stakeholders are notified of incidents."
    // Notifying is part of responding, so both readings stand; the
    // notification control is the primary because it is what the
    // subcategory is actually about, and no NIST subcategory reached it
    // before (GH #6844).
    { primary: true, externalId: 'RS.CO-02', scfId: 'SCF-INC-006', ref: 'RS.CO-02' },
    { externalId: 'RS.CO-02', scfId: 'SCF-INC-003', ref: 'RS.CO-02' },
    { externalId: 'RS.CO-03', scfId: 'SCF-GOV-005', ref: 'RS.CO-03' },
    { externalId: 'RS.MI-01', scfId: 'SCF-INC-003', ref: 'RS.MI-01' },
    { externalId: 'RS.MI-02', scfId: 'SCF-INC-003', ref: 'RS.MI-02' },
    { externalId: 'RC.RP-01', scfId: 'SCF-BCM-001', ref: 'RC.RP-01' },
    { externalId: 'RC.RP-02', scfId: 'SCF-BCM-002', ref: 'RC.RP-02' },
    { externalId: 'RC.RP-03', scfId: 'SCF-BCM-002', ref: 'RC.RP-03' },
    { externalId: 'RC.RP-04', scfId: 'SCF-BCM-002', ref: 'RC.RP-04' },
    { externalId: 'RC.RP-05', scfId: 'SCF-BCM-002', ref: 'RC.RP-05' },
    { externalId: 'RC.RP-06', scfId: 'SCF-BCM-001', ref: 'RC.RP-06' },
    { externalId: 'RC.CO-03', scfId: 'SCF-INC-003', ref: 'RC.CO-03' },
    { externalId: 'RC.CO-04', scfId: 'SCF-MSS-003', ref: 'RC.CO-04' },
  ],
};

module.exports = {
  FRAMEWORK_NIST_CSF20,
};
